import React, { useEffect, useState } from "react";
import AuthService from "../services/authService";
import Spinner from "./Spinner";
import Fuse from "fuse.js";

interface Team {
  id: number;
  team_name: string;
  img_url?: string;
}

const TeamList: React.FC = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
   const [search, setSearch] = useState("");

  const authService = new AuthService();
  

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = async () => {
    setLoading(true);
    try {
      const response = await authService.getRecentTeams();
      if (response.status === 200) {
        setTeams(response.data || []);
      } else {
        setError("Failed to load teams");
      }
    } catch (err) {
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner />
      </div>
    );
  }


const fuse = new Fuse(teams, {
  keys: ["team_name"],
  threshold: 0.2, // lower = stricter, higher = more fuzzy
});

const filteredTeams = search
  ? fuse.search(search).map(result => result.item)
  : teams;





  if (error) {
    return <p className="text-red-600">{error}</p>;
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
       <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Team List</h2>

        {/* Search Bar */}
        <input
          type="text"
          placeholder="Search teams..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border border-gray-300 rounded-md px-3 py-2 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="divide-y divide-gray-200">
        {filteredTeams.map((team) => (
          <div
            key={team.id}
            className="flex items-center gap-4 py-3 hover:bg-gray-50 transition"
          >
            {/* Logo */}
            <div className="w-12 h-12 flex-shrink-0">
              {team.img_url ? (
                <img
                  src={team.img_url}
                  alt={team.team_name}
                  className="w-12 h-12 object-contain"
                />
              ) : (
                <div className="w-12 h-12 bg-gray-200 flex items-center justify-center rounded text-xs text-gray-500">
                  No Logo
                </div>
              )}
            </div>

            {/* Team Name */}
            <div className="font-semibold text-gray-800">
              {team.team_name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamList;